import React, { memo, forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useMediaQuery } from 'react-responsive';

import { PhotoGridScrollContext } from '../../../../components/grid/PhotoGrid';
import { breakpointDown } from '../../../../services/responsive/responsive';
import useBasename from '../../../../components/routing/useBasename';
import { BASENAME } from '../../../../constants/basenames';

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

const MainContent = memo(
  // eslint-disable-next-line react/prop-types
  forwardRef(({ children, className }, ref) => {
    const isMobile = useMediaQuery(breakpointDown('md'));
    const basename = useBasename();

    const classes = classNames({
      'pro-wrapper-main-content': true,
      // --- Adding the SB logic here because otherwise
      // We need to update this in a ton of places. I rather have this self-contained
      // In case we change it :)
      // By: Luis Rojas.
      'pro-wrapper-main-content-no-nav':
        basename === BASENAME.SHUTTERBUG || !isMobile,
      [className]: !!className,
    });

    return (
      <div className={classes} ref={ref}>
        <PhotoGridScrollContext.Provider value={isMobile ? window : ref}>
          <div className="pro-wrapper-main-content-pad">{children}</div>
        </PhotoGridScrollContext.Provider>
      </div>
    );
  }),
);

MainContent.propTypes = propTypes;
MainContent.displayName = 'MainContent';

export default MainContent;
